import { FC, MouseEvent, useEffect, useState } from 'react';

import { CloseOutlined } from '@ant-design/icons';

import styles from './PromoBanner.module.scss';

const STORAGE_KEY = 'promo_banner_nr_collapsed';

// Глобальное скрытие рекламного баннера для всех школ.
// Код баннера сохранён — чтобы вернуть показ, поставь IS_PROMO_BANNER_ENABLED = true.
const IS_PROMO_BANNER_ENABLED = false;

type Props = {
  collapsed?: boolean;
};

const PromoBanner: FC<Props> = ({ collapsed }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        setIsCollapsed(true);
      }
    } catch (error) {
      console.error('PromoBanner localStorage read error:', error);
    }
  }, []);

  if (!IS_PROMO_BANNER_ENABLED) return null;

  if (collapsed) return null;

  const handleCollapse = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      console.error('PromoBanner localStorage write error:', error);
    }
    setIsCollapsed(true);
  };

  const handleExpand = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('PromoBanner localStorage remove error:', error);
    }
    setIsCollapsed(false);
  };

  const handleBannerClick = () => {
    window.open('/nr', '_blank', 'noopener,noreferrer');
  };

  if (isCollapsed) {
    return (
      <button
        type="button"
        className={styles.collapsedLink}
        onClick={handleExpand}
        aria-label="Развернуть баннер Окупаемая реклама"
      >
        Окупаемая реклама
      </button>
    );
  }

  return (
    <div
      className={styles.banner}
      onClick={handleBannerClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleBannerClick();
      }}
    >
      <img className={styles.image} src="/nr2.jpg" alt="VK Реклама" />
      <button
        type="button"
        className={styles.close}
        onClick={handleCollapse}
        aria-label="Свернуть баннер"
      >
        <CloseOutlined />
      </button>
    </div>
  );
};

export default PromoBanner;
